export default __webpack_public_path__ + "/assets/fonts/inria-serif-latin-300-normal.woff2";